var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5632 8.6293C11.3952 8.6293 9.5872 7.3013 7.6832 7.3493C5.1712 7.3813 2.8672 8.8053 1.5712 11.0613C-1.0368 15.5893 0.899202 22.2773 3.4432 25.9573C4.6912 27.7493 6.1632 29.7653 8.1152 29.7013C9.9872 29.6213 10.6912 28.4853 12.9632 28.4853C15.2192 28.4853 15.8592 29.7013 17.8432 29.6533C19.8592 29.6213 21.1392 27.8293 22.3712 26.0213C23.7952 23.9413 24.3872 21.9253 24.4192 21.8133C24.3712 21.7973 20.4992 20.3093 20.4512 15.8293C20.4192 12.0853 23.5072 10.2933 23.6512 10.2133C21.8912 7.6373 19.1872 7.3493 18.2432 7.2853C15.7792 7.0933 13.7152 8.6293 12.5632 8.6293ZM16.7232 4.8533C17.7632 3.6053 18.4512 1.8613 18.2592 0.133301C16.7712 0.197301 14.9792 1.1253 13.9072 2.3733C12.9472 3.4773 12.1152 5.2533 12.3392 6.9493C13.9872 7.0773 15.6832 6.1013 16.7232 4.8533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.1dbb756b7f5184593bc58b9e98065699.svg";
export { ForwardRef as ReactComponent };